import { render } from "./ZavbusServiceListPage.vue?vue&type=template&id=fdacb3e0"
import script from "./ZavbusServiceListPage.vue?vue&type=script&lang=ts"
export * from "./ZavbusServiceListPage.vue?vue&type=script&lang=ts"

import "./ZavbusServiceListPage.vue?vue&type=style&index=0&id=fdacb3e0&lang=css"
script.render = render

export default script